/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsTransferUp = createReactComponent(
  "arrows-transfer-up",
  "IconArrowsTransferUp",
  [
    ["path", { d: "M7 21v-6", key: "svg-0" }],
    ["path", { d: "M20 6l-3 -3l-3 3", key: "svg-1" }],
    ["path", { d: "M17 3v18", key: "svg-2" }],
    ["path", { d: "M10 18l-3 3l-3 -3", key: "svg-3" }],
    ["path", { d: "M7 3v2", key: "svg-4" }],
    ["path", { d: "M7 9v2", key: "svg-5" }]
  ]
);

export { IconArrowsTransferUp as default };
//# sourceMappingURL=IconArrowsTransferUp.js.map
